<app-header></app-header>

<section>
  <div class="container">
    <div class="col-sm-12">
      <div class="text-center">
        <div class="forgotdiv">
          <h2>Contact Details</h2>
          <hr />

          <form [formGroup]="form">
            <div class="row text-start mb-3">
              <div class="col-md-4">
                <label class="nowrap">Mobile Number <span class="text-danger">*</span></label>
                <input type="text" autocomplete="off" id="txtMobNum" class="form-control" formControlName="ownersMobileNumber" (keypress)="numberOnly($event)"
                       placeholder="Enter Mobile Number" maxlength="10" minlength="10">
                <div *ngIf="f['ownersMobileNumber'].touched && f['ownersMobileNumber'].invalid" class="alert alert-danger">
                  <div *ngIf="f['ownersMobileNumber'].errors && f['ownersMobileNumber'].errors['required']">
                    Mobile number is required
                  </div>
                  <div *ngIf="f['ownersMobileNumber'].errors && f['ownersMobileNumber'].errors['pattern']">
                    Entered phone number is invalid. Please re-enter the phone number
                  </div>
                </div>
              </div>

              <div class="col-md-5">
                <label class="nowrap">Enter otp received on Mobile <span class="text-danger">*</span></label>
                <input type="text" autocomplete="off" id="txtMobOTP" class="form-control" formControlName="mobotp" (keypress)="numberOnly($event)"
                       placeholder="Enter OTP sent on your mobile No." minlength="6" maxlength="6">
                <div *ngIf="f['mobotp'].touched && f['mobotp'].invalid" class="alert alert-danger">
                  <div *ngIf="f['mobotp'].errors && f['mobotp'].errors['required']">
                    Enter otp sent to your mobile
                  </div>
                  <div *ngIf="f['mobotp'].errors && f['mobotp'].errors['minLength']">
                    OTP should be of length 6 digits only
                  </div>
                  <div *ngIf="f['mobotp'].errors && f['mobotp'].errors['maxLength']">
                    OTP should be of length 6 digits only
                  </div>
                  <div *ngIf="f['mobotp'].errors && f['mobotp'].errors['pattern']">
                    Entered Mobile OTP is incorrect. Please enter correct OTP
                  </div>
                </div>
              </div>
              <div class="col-md-3 mt-4">
                <button id="btnverifyotp" type="button" (click)="verifyMobileOtp()" [disabled]="isVerifyMobileOtpButtonDisabled" class="btn btn-success btn-sm mt-1">Verify Mobile OTP</button>
              </div>
            </div>

            <div class="row text-start mb-3">
              <div class="col-md-12">
                <button id="btnsendotp" type="button" (click)="SendOTP()" [disabled]="isButtonMobileDisabled || mobileOtpTimerRunning" class="btn btn-primary btn-sm mt-1">Send Mobile OTP</button>
                <button id="btnresendotp" type="button" (click)="ReSendMobileOTP()" [disabled]="resendMobileOtpDisabled || mobileOtpTimerRunning" class="btn btn-primary btn-sm mt-1">
                  Resend Mobile OTP
                  <span *ngIf="mobileOtpTimerRunning">{{ mobileOtpTimer }} seconds</span>
                </button>
              </div>
            </div>



            <div class="row text-start mb-3">
              <div class="col-md-4">
                <label class="nowrap">Email ID <span class="text-danger">*</span></label>
                <input type="text" autocomplete="off" id="txtemail" class="form-control" formControlName="email"
                       placeholder="Enter Email Id" maxlength="50" minlength="8">
                <div *ngIf="f['email'].touched && f['email'].invalid" class="alert alert-danger">
                  <div *ngIf="f['email'].errors && f['email'].errors['required']">
                    Email is required
                  </div>
                  <div *ngIf="f['email'].errors && f['email'].errors['minlength']">
                    Minimum length should be 8 characters
                  </div>
                  <div *ngIf="f['email'].errors && f['email'].errors['maxlength']">
                    Maximum length shouldnot be more than 40 characters
                  </div>
                  <div *ngIf="f['email'].errors && f['email'].errors['pattern']">
                    Enter Email address is invalid. Please re-enter the email address
                  </div>
                </div>
              </div>

              <!--<div class="col-md-5">
                <label class="nowrap">Enter otp received on email <span class="text-danger">*</span></label>
                <input type="text" autocomplete="off" id="txtemailOTP" class="form-control" formControlName="emailotp" (keypress)="numberOnly($event)"
                       placeholder="Enter OTP sent to your email" minlength="6" maxlength="6">
                <div *ngIf="f['emailotp'].touched && f['emailotp'].invalid" class="alert alert-danger">
                  <div *ngIf="f['emailotp'].errors && f['emailotp'].errors['required']">
                    Enter otp sent to your email
                  </div>
                  <div *ngIf="f['emailotp'].errors && f['emailotp'].errors['minLength']">
                    OTP should be of length 6 digits only
                  </div>
                  <div *ngIf="f['emailotp'].errors && f['emailotp'].errors['maxLength']">
                    OTP should be of length 6 digits only
                  </div>
                  <div *ngIf="f['emailotp'].errors && f['emailotp'].errors['pattern']">
                    Entered email OTP is incorrect. Please enter correct OTP
                  </div>
                </div>
              </div>
              <div class="col-md-3 mt-4">
                <button id="btnverifyotp" type="button" (click)="verifyEmailOtp()" [disabled]="isVerifyEmailOtpButtonDisabled" class="btn btn-success btn-sm mt-1">Verify Email OTP</button>
              </div>-->
            </div>
            <!--<div class="row text-start mb-3">
              <div class="col-md-12">
                <button id="btnsendemailotp" type="button" (click)="SendEmailOTP()" [disabled]="isButtonEmailDisabled || emailOtpTimerRunning" class="btn btn-primary btn-sm mt-1">Send Email OTP</button>
                <button id="btnresendemailotp" type="button" (click)="ReSendEmailOTP()" [disabled]="resendEmailOtpDisabled || emailOtpTimerRunning" class="btn btn-primary btn-sm mt-1">
                  Resend Email OTP
                  <span *ngIf="emailOtpTimerRunning">{{ emailOtpTimer }} seconds</span>
                </button>
              </div>
            </div>-->
            <button id="btngotocontact" type="button" (click)="goto(form)" [disabled]="!otpSuccess" class="btn btn-success">Save</button>
            <button id="btncancel" type="button" (click)="onReset()" class="btn btn-danger">Cancel</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
<app-footer></app-footer>

